import {
  ClientValue,
  FeeEarnerCascaderValue,
  PracticeArea,
  PricingLevel,
  PricingType,
  PricingTarget,
  PricingStructureCascaderValue,
} from "../data-types";

export type OrgUnitCascaderValue = [] | [number] | [number, number];

export const orgUnitCascaderValue = (
  pa: PracticeArea[] | undefined,
  id?: number | undefined
): OrgUnitCascaderValue => {
  if (!pa || !id) {
    return [];
  }
  const item = pa.find((p) => p.id === id);

  if (item?.parent) {
    const parent = pa.find((p) => p.id === item.parent?.id);
    return [parent!.id, item.id];
  } else {
    return item ? [item.id] : [];
  }
};

export const templateFormValuesToMatterData = (formValues: {
  title: string | undefined;
  client: ClientValue | undefined;
  pricingStructure: PricingStructureCascaderValue | undefined;
  practiceAreaId: OrgUnitCascaderValue | undefined;
  leadFeeEarner: FeeEarnerCascaderValue | undefined;
  matterTaxExempt: boolean | undefined;
}) => {
  if (!formValues) {
    return undefined;
  }

  let pricingType: PricingType = PricingType.None;
  let pricingLevel: PricingLevel = PricingLevel.None;
  let pricingTarget: PricingTarget | null = null;
  const pricingStructure = formValues?.pricingStructure;
  if (pricingStructure) {
    if (pricingStructure[0] === "BottomUp") {
      pricingType = pricingStructure[2];
      pricingLevel = pricingStructure[1];
    } else if (pricingStructure[0] === "TopDown") {
      pricingType = PricingType.TopDown;
      pricingLevel = pricingStructure[1];
      pricingTarget = pricingStructure[2];
    }
  }

  return {
    title: formValues?.title ? formValues?.title : undefined,
    client: formValues?.client ? formValues.client : undefined,
    pricingLevel: pricingLevel,
    pricingType: pricingType,
    practiceAreaId: formValues?.practiceAreaId,
    pricingTarget: pricingTarget,
    leadFeeEarner: formValues?.leadFeeEarner ? formValues.leadFeeEarner : undefined,
    matterTaxExempt:
      formValues?.matterTaxExempt === true || formValues?.matterTaxExempt === false
        ? formValues.matterTaxExempt
        : undefined,
  };
};
